//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ImportTemplateQuestionsModal',
  props: {
    projectId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      loadingTemplates: false,
      importingTemplateId: null,
      selectedTemplateId: null,
      selectedTemplateHighestAssignedPhase: null
    }
  },
  computed: {
    ...mapGetters({
      projectPhaseCount: 'projects/getActiveProjectPhaseCount',
      templates: 'templates/getTemplates'
    }),
    displayImportAlert() {
      return this.selectedTemplateId
    },
    isImporting() {
      return this.importingTemplateId !== null
    }
  },
  async mounted() {
    this.loadingTemplates = true
    await this.fetchTemplateList()
    this.loadingTemplates = false
  },
  methods: {
    ...mapActions({
      applyTemplateToProject: 'templates/applyTemplateToProject',
      fetchTemplateList: 'templates/fetchTemplateList',
      fetchHighestAssignedPhase: 'templates/getHighestPhaseForTemplateQuestions'
    }),
    async selectTemplateConfirm(id) {
      this.importingTemplateId = id
      try {
        const highestAssignedPhase = await this.fetchHighestAssignedPhase(id)
        if (highestAssignedPhase > this.projectPhaseCount) {
          this.selectedTemplateId = id
          this.selectedTemplateHighestAssignedPhase = highestAssignedPhase
          this.importingTemplateId = null
          return
        }
        await this.selectTemplate(id)
      } catch (error) {
        this.importingTemplateId = null
        throw error
      }
    },
    async selectTemplate(id, updatePhase = false) {
      this.loadingTemplates = true
      this.importingTemplateId = id
      try {
        await this.applyTemplateToProject({ projectId: this.projectId, templateId: id, updatePhase })
        this.selectedTemplateId = null
        this.selectedTemplateHighestAssignedPhase = null
        this.$emit('imported')
        this.$bvModal.hide('modal-import-template-questions')
      } finally {
        this.loadingTemplates = false
        this.importingTemplateId = null
      }
    }
  }
}
